module.exports = __webpack_public_path__ + "static/media/pla_sel_sui.9a988f93.png";